import React from 'react';
export function Footer() {
  return <footer className="border-t border-neutral-200 bg-white pb-8 pt-16" data-id="element-23">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-24">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-4 lg:gap-8" data-id="element-25">
          {/* Brand Col */}
          <div className="md:col-span-1" data-id="element-26">
            <div className="flex items-center gap-2" data-id="element-27">
              <div className="h-4 w-4 rounded-sm bg-[#FF6B1A]" data-id="element-28" />
              <span className="text-sm font-semibold tracking-tight text-neutral-900" data-id="element-29">
                indiastartups.in
              </span>
            </div>
            <p className="mt-4 text-sm text-neutral-500" data-id="element-30">
              The home for India's AI startups. Discover, track, and connect
              with the fastest-growing companies.
            </p>
            <div className="mt-6 inline-flex items-center rounded-full border border-neutral-200 bg-neutral-50 px-2.5 py-1 text-xs font-medium text-neutral-600" data-id="element-31">
              <span className="mr-1.5" data-id="element-32">🇮🇳</span> Made in India
            </div>
          </div>

          {/* Links Col 1 */}
          <div data-id="element-33">
            <h3 className="text-sm font-semibold text-neutral-900" data-id="element-34">
              Directory
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-neutral-500" data-id="element-35">
              <li data-id="element-36">
                <a href="#" className="hover:text-neutral-900 transition-colors" data-id="element-37">
                  All Startups
                </a>
              </li>
              <li data-id="element-38">
                <a href="#" className="hover:text-neutral-900 transition-colors" data-id="element-39">
                  Categories
                </a>
              </li>
              <li data-id="element-40">
                <a href="#" className="hover:text-neutral-900 transition-colors" data-id="element-41">
                  Featured
                </a>
              </li>
              <li data-id="element-42">
                <a href="#" className="hover:text-neutral-900 transition-colors" data-id="element-43">
                  Submit a Startup
                </a>
              </li>
            </ul>
          </div>

          {/* Links Col 2 */}
          <div data-id="element-44">
            <h3 className="text-sm font-semibold text-neutral-900" data-id="element-45">
              Resources
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-neutral-500" data-id="element-46">
              <li data-id="element-47">
                <a href="#" className="hover:text-neutral-900 transition-colors" data-id="element-48">
                  About Us
                </a>
              </li>
              <li data-id="element-49">
                <a href="#" className="hover:text-neutral-900 transition-colors" data-id="element-50">
                  API Access
                </a>
              </li>
              <li data-id="element-51">
                <a href="#" className="hover:text-neutral-900 transition-colors" data-id="element-52">
                  Newsletter
                </a>
              </li>
              <li data-id="element-53">
                <a href="#" className="hover:text-neutral-900 transition-colors" data-id="element-54">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter Col */}
          <div data-id="element-55">
            <h3 className="text-sm font-semibold text-neutral-900" data-id="element-56">
              Stay updated
            </h3>
            <p className="mt-4 text-sm text-neutral-500" data-id="element-57">
              Get a weekly digest of new AI startups and funding news.
            </p>
            <form className="mt-4 flex max-w-sm gap-2" onSubmit={e => e.preventDefault()} data-id="element-58">
              <input type="email" placeholder="Enter your email" className="w-full rounded-lg border border-neutral-200 bg-white px-3 py-2 text-sm placeholder:text-neutral-400 focus:border-neutral-300 focus:outline-none focus:ring-2 focus:ring-neutral-100" data-id="element-59" />
              <button type="submit" className="shrink-0 rounded-lg bg-black px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-neutral-800 focus:outline-none focus:ring-2 focus:ring-neutral-400 focus:ring-offset-2" data-id="element-60">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-center justify-between border-t border-neutral-100 pt-8 sm:flex-row" data-id="element-61">
          <p className="text-sm text-neutral-500" data-id="element-62">
            © {new Date().getFullYear()} IndianStartups.in. All rights
            reserved.
          </p>
          <div className="mt-4 flex gap-4 sm:mt-0" data-id="element-63">
            <a href="#" className="text-neutral-400 hover:text-neutral-900 transition-colors" data-id="element-64">
              <span className="sr-only" data-id="element-65">X (Twitter)</span>
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-66">
                <path d="M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75404L10.7663 14.0113L15.5685 21H20.8131L13.6819 10.6218H13.6823ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.096V13.0956Z" data-id="element-67" />
              </svg>
            </a>
            <a href="#" className="text-neutral-400 hover:text-neutral-900 transition-colors" data-id="element-68">
              <span className="sr-only" data-id="element-69">GitHub</span>
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-70">
                <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" data-id="element-71" />
              </svg>
            </a>
            <a href="#" className="text-neutral-400 hover:text-neutral-900 transition-colors" data-id="element-72">
              <span className="sr-only" data-id="element-73">LinkedIn</span>
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-74">
                <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" data-id="element-75" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>;
}